module.exports = __webpack_public_path__ + "static/media/accesorios.635d9ad2.png";